import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    cardContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: '20px',
    },
    mobileCardContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        margin: '20px',
    },
    bar: {
        background: 'white',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '20px',
        width: '940px',
        textAlign: 'center',
        margin: '10px 30px',
    },
    mobileBar: {
        background: 'white',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '20px',
        width: '300px',
        textAlign: 'center',
        margin: '10px 30px',
    },
    card: {
        background: 'white',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        padding: '20px',
        width: '300px',
        textAlign: 'center',
        margin: '10px 10px',
    },
    icon: {

        marginBottom: '20px',
    },
    heading: {
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    info: {
        marginBottom: '10px',
        lineHeight: '1.5',
        color: '#333',
    },
}));
